import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import GGEditorCore from 'gg-editor-core';
import { EVENT_BEFORE_ADD_PAGE } from "../../common/constants";
import track from "../../helpers/track";
import { uniqueId } from "../../utils";

var Editor =
/*#__PURE__*/
function (_GGEditorCore) {
  _inherits(Editor, _GGEditorCore);

  function Editor(options) {
    var _this;

    _classCallCheck(this, Editor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Editor).call(this, options));
    _this.id = uniqueId();

    _this.on(EVENT_BEFORE_ADD_PAGE, function (_ref) {
      var className = _ref.className;
      track({
        c1: className
      });
    });

    return _this;
  }

  return Editor;
}(GGEditorCore);

export { Editor as default };